export default (pageFolder) => ({
  nodeId: pageFolder.pageFolderId,
  nodeType: pageFolder.pageFolderType,
  ...pageFolder,
});
